import React, { useEffect, useRef, useState } from "react";

const PaypalButton = ({ amount, onSuccess, height = 40, onCancel }) => {
  const paypalRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let isMounted = true;
    const handlePaypalScriptError = (event) => {
      if (event?.message === "Script error.") {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };

    window.addEventListener("error", handlePaypalScriptError, true);

    const loadPaypalScript = () => {
      return new Promise((resolve, reject) => {
        if (window.paypal) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src =
          "https://www.paypal.com/sdk/js?client-id=AR4eQMHHohbu-p8XWP6GdBlL3w7RV9-yLChe8KiBxk8kNee750yVR4OsaKweOW_EW8a__XCEQSOM4mjW&currency=USD";
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error("Unable to load PayPal."));
        document.body.appendChild(script);
      });
    };

    const renderButton = () => {
      if (!window.paypal || !paypalRef.current) return;
      if (!amount || Number(amount) <= 0) return;

      setErrorMessage("");
      paypalRef.current.innerHTML = "";

      try {
        const buttons = window.paypal.Buttons({
          style: {
            height: height,
          },

          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: Number(amount).toFixed(2),
                  },
                },
              ],
            });
          },

          onApprove: (data, actions) => {
            return actions.order.capture().then((details) => {
              onSuccess && onSuccess(details);
            });
          },

          onCancel: (data) => {
            onCancel && onCancel(data);
          },

          onError: (err) => {
            console.error("PayPal Error:", err);
            if (isMounted) {
              setErrorMessage("PayPal is temporarily unavailable. Please try again.");
            }
          },
        });

        if (buttons.isEligible && !buttons.isEligible()) {
          setErrorMessage("PayPal is not available for this payment.");
          return;
        }

        buttons.render(paypalRef.current).catch((err) => {
          console.error("PayPal Render Error:", err);
          if (isMounted) {
            setErrorMessage("PayPal is temporarily unavailable. Please try again.");
          }
        });
      } catch (err) {
        console.error("PayPal Button Error:", err);
        if (isMounted) {
          setErrorMessage("PayPal is temporarily unavailable. Please try again.");
        }
      }
    };

    loadPaypalScript()
      .then(() => {
        if (isMounted) {
          renderButton();
        }
      })
      .catch((err) => {
        console.error("PayPal Script Error:", err);
        if (isMounted) {
          setErrorMessage("PayPal is temporarily unavailable. Please try again.");
        }
      });

    return () => {
      isMounted = false;
      window.removeEventListener("error", handlePaypalScriptError, true);
      if (paypalRef.current) {
        paypalRef.current.innerHTML = "";
      }
    };
  }, [amount, height]);

  return (
    <>
      <div ref={paypalRef}></div>
      {errorMessage ? (
        <p className="register-error-message">{errorMessage}</p>
      ) : null}
    </>
  );
};

export default PaypalButton;
